import React from "react";
import { BreadcrumbGroup } from "@amzn/awsui-components-react-v3";

interface BreadcrumbItem {
  href: string;
  text: string;
}

export const Breadcrumbs = ({ items }: { items: BreadcrumbItem[] }) => (
  <BreadcrumbGroup
    items={items}
    expandAriaLabel="Show path"
    ariaLabel="Breadcrumbs"
  />
);
